import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import OnlineStatus from '../chat/OnlineStatus';
import { showRoom } from '../../actions/ChatActions';
import ModalContext from './ModalContext';

const PageLockedDialog = props => {
  const { lockedBy, showRoom, users } = props;
  const { close } = useContext(ModalContext);

  const getOnlineStatus = userId => {

    for (const user of users) {
      if (user.id === userId) {
        return user.status;
      }
    }

    return 'Offline';
  };

  return (
    <div className="locked">
    This record is currently locked by another user, therefore it is read-only.  You have the option of removing the lock, <b>however that may result in that user losing any unsaved work</b>.  The user who owns the lock is listed below.
    <div
      className="locked-by"
      onClick={() => {
        close();
        showRoom(lockedBy);
      }}
    >
      <OnlineStatus status={getOnlineStatus(lockedBy.id)} />
      {lockedBy.firstName} {lockedBy.lastName}<br />
      {lockedBy.email}
    </div>
    </div>
  );
};

PageLockedDialog.propTypes = {
  lockedBy: PropTypes.object,
  showRoom: PropTypes.func,
  users: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    users: state.chat.users,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showRoom }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PageLockedDialog);
